console.log("process.env.SOUL_CONTRACT_ADDRESS: ", process.env.REACT_APP_SOUL_CONTRACT_ADDRESS);
export const soulContractAddress = process.env.REACT_APP_SOUL_CONTRACT_ADDRESS;
